import React from 'react';
import { Row, Col } from 'reactstrap';
import { Field } from "formik";
import { NeoInput } from '../../../../components/Common';

const GamificationAttendancePoints = () => {
    return (
        <>
            <div className="mb-4 d-flex align-items-center">
                <div className="neo-section-icon-circle flex-shrink-0">
                    <i className="mdi mdi-calendar-check-outline font-size-18 text-accent" />
                </div>
                <div className="ms-3">
                    <h5 className="mb-0 fw-bold text-dark neo-font-outfit font-size-15">Pontuação por Frequência</h5>
                    <p className="text-muted mb-0 font-size-12">Defina o XP concedido por presenças e faltas para alunos e professores.</p>
                </div>
            </div>
            
            <Row className="g-4">
                {/* CONFIGURAÇÃO DO ALUNO */}
                <Col md={6}>
                    <div className="neo-gamification-card h-100">
                        <div className="d-flex align-items-center gap-2 mb-4">
                            <div className="neo-section-icon-circle flex-shrink-0" style={{ width: '32px', height: '32px' }}>
                                <i className="mdi mdi-account-outline font-size-16 text-accent"></i>
                            </div>
                            <h6 className="fw-bold font-size-13 mb-0 text-dark neo-font-outfit">
                                Configuração do Aluno
                            </h6>
                        </div>

                        <Field name="memberAttendancePresent">
                            {({ field, meta }) => (
                                <NeoInput
                                    {...field}
                                    type="number"
                                    label="Presença Confirmada (XP) *"
                                    placeholder="Ex: 10"
                                    error={meta.touched && meta.error ? meta.meta : ''}
                                    className="mb-3"
                                />
                            )}
                        </Field>

                        <Field name="memberAttendanceExcused">
                            {({ field, meta }) => (
                                <NeoInput
                                    {...field}
                                    type="number"
                                    label="Falta Justificada (XP)"
                                    placeholder="Ex: 2"
                                    error={meta.touched && meta.error ? meta.error : ''}
                                    className="mb-3"
                                />
                            )}
                        </Field>

                        <Field name="memberAttendanceUnexcused">
                            {({ field, meta }) => (
                                <NeoInput
                                    {...field}
                                    type="number"
                                    label="Falta Injustificada (XP)"
                                    placeholder="Ex: -5"
                                    error={meta.touched && meta.error ? meta.error : ''}
                                    className="mb-0"
                                />
                            )}
                        </Field>
                    </div>
                </Col>

                {/* CONFIGURAÇÃO DO PROFESSOR */}
                <Col md={6}>
                    <div className="neo-gamification-card h-100">
                        <div className="d-flex align-items-center gap-2 mb-4">
                            <div className="neo-section-icon-circle flex-shrink-0" style={{ width: '32px', height: '32px' }}>
                                <i className="mdi mdi-teach font-size-16 text-accent"></i>
                            </div>
                            <h6 className="fw-bold font-size-13 mb-0 text-dark neo-font-outfit">
                                Configuração do Professor
                            </h6>
                        </div>

                        <Field name="teacherAttendancePresent">
                            {({ field, meta }) => (
                                <NeoInput
                                    {...field}
                                    type="number"
                                    label="Presença Confirmada (XP) *"
                                    placeholder="Ex: 15"
                                    error={meta.touched && meta.error ? meta.error : ''}
                                    className="mb-3"
                                />
                            )}
                        </Field>

                        <Field name="teacherAttendanceExcused">
                            {({ field, meta }) => (
                                <NeoInput
                                    {...field}
                                    type="number"
                                    label="Falta Justificada (XP)"
                                    placeholder="Ex: 5"
                                    error={meta.touched && meta.error ? meta.error : ''}
                                    className="mb-3"
                                />
                            )}
                        </Field>

                        <Field name="teacherAttendanceUnexcused">
                            {({ field, meta }) => (
                                <NeoInput
                                    {...field}
                                    type="number"
                                    label="Falta Injustificada (XP)"
                                    placeholder="Ex: 0"
                                    error={meta.touched && meta.error ? meta.error : ''}
                                    className="mb-0"
                                />
                            )}
                        </Field>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default GamificationAttendancePoints;
